<template>
    <div class="transparent-header">
        <div class="mask" :style="{backgroundColor: color, opacity: customOpacity || opacity}"></div>
        <div class="page-header-con">
            <slot name="left-back">
                <div class="back-btn" @click="pageBack">
                    <div v-if="!switchType" class="btn" :class="[`btn${type}`]" :style="{'backgroundColor': pageBackBg}"></div>
                    <div v-else class="btn" :class="[`btn${opacity < switchThreshold ? 1 : 2}`]"></div>
                </div>
            </slot>
            <div class="page-title" :style="{color: titleColor,opacity: titleCustomOpacity ? titleCustomOpacity : customOpacity || opacity}">
                <slot name="title">
                    {{pageTitle || defaultTitle}}
                </slot>
            </div>

            <div class="right-btn">
                <slot name="right-btn" :data="{opacity, switchThreshold}">
                    <div class="opt-btn-wrap" :class="[{'type1': !switchType && type == 1}, {'type2': !switchType && type == 2}, {'type1': switchType && opacity < switchThreshold }, {'type2': switchType && opacity >= switchThreshold }]">
                        <div class="refresh-btn" @click="pageRefresh">
                            <div v-if="!switchType" class="btn" :class="[`btn${type}`]"></div>
                            <div v-else class="btn" :class="[`btn${opacity < switchThreshold ? 1 : 2}`]"></div>
                        </div>
                        <div class="close-btn" @click="pageClose">
                            <div v-if="!switchType" class="btn" :class="[`btn${type}`]"></div>
                            <div v-else class="btn" :class="[`btn${opacity < switchThreshold ? 1 : 2}`]"></div>
                        </div>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import {getPlatform, share} from '@/common/utils'

    const {isGYApp} = getPlatform()
    export default {
        name: "TransparentHeader",
        props: {
            color: {
                type: String,
                default: '#F5F5F5'
            },
            titleColor: {
                type: String,
                default: '#1A1A1A'
            },
            scrollHeight: {
                type: Number,
                default: 200
            },
            pageTitle: {
                default: ''
            },
            pageBackBg: {
                default: 'rgba(0, 0, 0, 0.3)'
            },
            customMethods: {
                type: Array,
                default: function () {
                    return []
                }
            },
            customOpacity: {
                type: Number,
                default: 0
            },
            titleCustomOpacity: {
                type: Number,
                default: 0
            },
            type: {
                default: 1
            },
            switchType: Boolean,
            switchThreshold: {
                default: 0.8
            }
        },
        data() {
            return {
                opacity: 0,
            }
        },
        computed: {
            defaultTitle() {
                return window.document.title
            }
        },
        mounted() {
            window.addEventListener('scroll', this.changeOpacity, true)
        },
        destroyed() {
            window.removeEventListener('scroll', this.changeOpacity, true)
        },
        methods: {
            changeOpacity() {
                let wait = 100
                if (!this.timeout) {
                    this.timeout = setTimeout(() => {
                        this.timeout = null;
                        let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                        this.opacity = scrollTop / this.scrollHeight < 1 ? scrollTop / this.scrollHeight : 1
                        this.$emit('opacityChange', this.opacity)
                    }, wait)
                }
            },
            pageBack() {
                if (this.customMethods.includes('pageBack')) {
                    this.$emit('pageBack')
                } else {
                    this.closePage()
                }
                this.$emit('afterBtnClick', 'pageBack')
            },
            pageRefresh() {
                if (this.customMethods.includes('pageRefresh')) {
                    this.$emit('pageRefresh')
                } else {
                    window.location.href = window.location.href
                }
                this.$emit('afterBtnClick', 'pageRefresh')
            },
            pageClose() {
                if (this.customMethods.includes('pageClose')) {
                    this.$emit('pageClose')
                } else {
                    this.closePage()
                }
                this.$emit('afterBtnClick', 'pageClose')
            },
            // 关闭webview
            closePage() {
                if (isGYApp) {
                    share.closeWebView()
                } else {
                    this.$router.back()
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .transparent-header {
        width: 100vw;
        height: 160px;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;

        .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
        }

        .page-header-con {
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding: 60px 24px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .back-btn {
            width: 60px;
            height: 60px;
            position: relative;

            .btn {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;

                &.btn1 {
                    background-color: rgba(0, 0, 0, .3);
                    background-image: url('~@/common/assets/img/TransparentHeader/free_icon_back.png');
                    background-size: 60px 60px;
                    background-position: center;
                    background-repeat: no-repeat;
                    border-radius: 50%;
                }

                &.btn2 {
                    background-image: url('~@/common/assets/img/TransparentHeader/free_icon_back_b.png');
                    background-size: 60px 60px;
                    border-radius: 50%;
                }
            }
        }

        .page-title {
            color: #ffffff;
            flex: 1;
            text-align: center;
            font-size: 34px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin: 0 auto;
            padding-left: 100px;
            padding-right: 160px;
        }

        .right-btn {
            position: absolute;
            right: 24px;
        }

        .opt-btn-wrap {
            padding: 0 9px;
            width: 160px;
            height: 60px;
            background: rgba(0, 0, 0, .3);
            border-radius: 30px;
            display: flex;
            justify-content: space-between;
            position: relative;

            &:after {
                content: '';
                display: block;
                width: 1px;
                height: 20px;
                background: rgba(179, 179, 179, .5);
                position: absolute;
                top: 20px;
                left: 80px;
            }
            &.type2 {
                background-color: inherit;
            }

            &.type2:after {
                background: #E6E6E6;
            }

            &.type2:before {
                content: '';
                display: block;
                width: 160px;
                height: 60px;
                border-radius: 30px;
                border: 1px solid #E6E6E6;
                position: absolute;
                top: 0;
                left: 0;
            }

            .refresh-btn {
                width: 60px;
                height: 60px;
                position: relative;

                .btn {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;

                    &.btn1 {
                        background-image: url('~@/common/assets/img/TransparentHeader/free_icon_Refresh.png');
                        background-size: 60px 60px;
                    }

                    &.btn2 {
                        background-image: url('~@/common/assets/img/TransparentHeader/free_icon_Refresh_b.png');
                        background-size: 60px 60px;
                    }
                }
            }

            .close-btn {
                width: 60px;
                height: 60px;
                position: relative;

                .btn {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;

                    &.btn1 {
                        background-image: url('~@/common/assets/img/TransparentHeader/free_icon_close.png');
                        background-size: 60px 60px;
                    }

                    &.btn2 {
                        background-image: url('~@/common/assets/img/TransparentHeader/free_icon_close_b.png');
                        background-size: 60px 60px;
                    }
                }
            }
        }
    }
</style>
